/**
 * CART SLIDER v4.5 — Production Build
 */
(function () {
  'use strict';

  var cfgEl = document.getElementById('cs-config');
  if (!cfgEl) return;
  var C;
  try {
    C = JSON.parse(cfgEl.textContent);
  } catch (e) {
    console.error('CS: invalid configuration', e);
    return;
  }

  var shopify = window.Shopify || {};
  var ROUTE_ROOT = (shopify.routes && shopify.routes.root) || '/';
  if (ROUTE_ROOT.charAt(ROUTE_ROOT.length - 1) !== '/') ROUTE_ROOT += '/';
  function route(path) { return ROUTE_ROOT + String(path || '').replace(/^\/+/, ''); }

  /* Resolve market-specific tier thresholds */
  if (C.tiers && C.tiers.length && (C.marketCode || C.marketRouteCode)) {
    C.tiers.forEach(function (t) {
      if (!t.marketOverrides) return;
      try {
        var overrides = JSON.parse(t.marketOverrides);
        var val = overrides[C.marketRouteCode] || overrides[C.marketCode] || overrides._default;
        if (val && val > 0) t.threshold = val * 100;
      } catch (e) {}
    });
  }

  var $ = function (s, p) { return (p || document).querySelector(s); };
  var $$ = function (s, p) { return Array.prototype.slice.call((p || document).querySelectorAll(s)); };

  var D = {};
  function cacheDom() {
    D.drawer = $('#cs-drawer'); D.overlay = $('#cs-overlay'); D.close = $('[data-cs-close]');
    D.body = $('[data-cs-body]'); D.items = $('[data-cs-items]'); D.empty = $('[data-cs-empty]');
    D.footer = $('[data-cs-footer]'); D.count = $('[data-cs-count]');
    D.progressBar = $('[data-cs-progress-bar]'); D.progressText = $('[data-cs-progress-text]');
    D.progressFill = $('[data-cs-progress-fill]'); D.progressTrack = $('[data-cs-progress-track]');
    D.milestones = $('[data-cs-milestones]');
    D.gift = $('[data-cs-gift]'); D.giftQty = $('[data-cs-gift-qty]');
    D.upsells = $('[data-cs-upsells]'); D.upsellsGrid = $('[data-cs-upsells-grid]'); D.total = $('[data-cs-total]');
    D.origTotal = $('[data-cs-orig-total]'); D.savings = $('[data-cs-savings]');
    D.savingsVal = $('[data-cs-savings-val]');
    D.discounts = $('[data-cs-discounts]');
    D.blocks = $('[data-cs-blocks]');
  }

  var isOpen = false, cart = null, scrollY = 0, highlightNext = false;
  var lastFocused = null, unlockTimer = null, savedBodyStyles = null;
  var refreshPromise = null, initialCartPromise = null, checkoutPending = false;

  /* ===== REQUEST QUEUE ===== */
  var queue = [], processing = false, pending = 0;
  function setBusy(busy) {
    var cta = document.querySelector('[data-cs-checkout]');
    if (!cta) return;
    cta.classList.toggle('is-busy', busy);
    cta.setAttribute('aria-disabled', busy ? 'true' : 'false');
    D.drawer && D.drawer.setAttribute('aria-busy', busy ? 'true' : 'false');
  }
  function enqueue(fn) {
    return new Promise(function (res, rej) {
      queue.push({ fn: fn, res: res, rej: rej });
      drain();
    });
  }
  function drain() {
    if (processing || !queue.length) { if (!queue.length && pending === 0) setBusy(false); return; }
    processing = true;
    pending++;
    setBusy(true);
    var j = queue.shift();
    Promise.resolve().then(j.fn).then(j.res, j.rej).finally(function () {
      processing = false;
      pending = Math.max(0, pending - 1);
      drain();
    });
  }

  /* ===== HELPERS ===== */
  function formatMoney(cents) {
    if (cents == null || isNaN(cents)) return '';
    var fmt = decHTML(C.moneyFormat || '${{amount}}').replace(/<[^>]*>/g, '');
    var n = cents / 100, amt = n.toFixed(2), nd = Math.round(n).toString();
    var p = amt.split('.'), w = p[0], d = p[1];
    function sep(s, c) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, c); }
    return fmt
      .replace('{{amount}}', sep(w, ',') + '.' + d)
      .replace('{{amount_no_decimals}}', sep(nd, ','))
      .replace('{{amount_with_comma_separator}}', sep(w, '.') + ',' + d)
      .replace('{{amount_no_decimals_with_comma_separator}}', sep(nd, '.'))
      .replace('{{amount_with_apostrophe_separator}}', sep(w, "'") + '.' + d)
      .replace('{{amount_no_decimals_with_space_separator}}', sep(nd, ' '))
      .replace('{{amount_with_space_separator}}', sep(w, ' ') + ',' + d)
      .replace('{{amount_with_period_and_space_separator}}', sep(w, ' ') + '.' + d)
      .replace('{{amount_no_decimals_with_period_and_space_separator}}', sep(nd, ' '));
  }

  var _dec;
  function decHTML(s) {
    if (!s) return '';
    if (!_dec) _dec = document.createElement('textarea');
    _dec.innerHTML = s;
    return _dec.value;
  }

  function fetchJSON(url, opts) {
    opts = opts || {};
    var isForm = typeof FormData !== 'undefined' && opts.body instanceof FormData;
    var headers = Object.assign({ Accept: 'application/json' }, opts.headers || {});
    if (!isForm && opts.body != null && !headers['Content-Type']) headers['Content-Type'] = 'application/json';
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timeout = controller ? setTimeout(function () { controller.abort(); }, C.requestTimeout || 15000) : null;
    return fetch(url, Object.assign({ credentials: 'same-origin' }, opts, {
      headers: headers,
      signal: controller ? controller.signal : opts.signal
    })).then(function (r) {
      return r.json().catch(function () { return null; }).then(function (data) {
        if (!r.ok) {
          var message = data && (data.description || data.message || data.status);
          throw new Error(message || (r.status + ' ' + r.statusText));
        }
        return data;
      });
    }).catch(function (e) {
      if (e && e.name === 'AbortError') throw new Error('Request timed out');
      throw e;
    }).finally(function () { if (timeout) clearTimeout(timeout); });
  }

  function esc(s) { if (!s) return ''; var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
  function escA(s) { if (!s) return ''; return s.replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/'/g,'&#39;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }

  function marketCodes(value) {
    return String(value || '').toLowerCase().split(',').map(function (code) { return code.trim(); }).filter(Boolean);
  }

  function marketAllowed(config) {
    if (!config) return true;
    var current = [C.marketCode, C.marketRouteCode].map(function (code) {
      return String(code || '').toLowerCase();
    }).filter(Boolean);
    var included = marketCodes(config.includedMarkets);
    var excluded = marketCodes(config.excludedMarkets);
    var includesAll = included.indexOf('all') !== -1 || included.indexOf('*') !== -1;
    var includedCurrent = current.some(function (code) { return included.indexOf(code) !== -1; });
    var excludedCurrent = current.some(function (code) { return excluded.indexOf(code) !== -1; });
    if (included.length && !includesAll && !includedCurrent) return false;
    if (excludedCurrent || excluded.indexOf('all') !== -1 || excluded.indexOf('*') !== -1) return false;
    return true;
  }

  function sizedImg(src, width) {
    if (!src || typeof src !== 'string' || src.indexOf('no-image') !== -1) return src || '';
    if (!/\/\/cdn\.shopify\.com\//i.test(src)) return src;
    if (/([?&])width=\d+/i.test(src)) return src.replace(/([?&])width=\d+/i, '$1width=' + width);
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function toast(msg) {
    var t = document.createElement('div');
    t.className = 'cs-error'; t.setAttribute('role', 'alert');
    t.textContent = msg || 'Something went wrong. Please try again.';
    document.body.appendChild(t);
    setTimeout(function () { if (t.parentNode) t.remove(); }, 3500);
  }

  function sbw() { return window.innerWidth - document.documentElement.clientWidth; }

  /* ===== CART API ===== */
  function getCart() { return fetchJSON(route('cart.js')); }
  function addToCart(id, qty, props, sp) {
    var it = { id: parseInt(id, 10), quantity: qty || 1 };
    if (props && Object.keys(props).length) it.properties = props;
    if (sp) it.selling_plan = parseInt(sp, 10);
    return fetchJSON(route('cart/add.js'), { method: 'POST', body: JSON.stringify({ items: [it] }) });
  }
  function addItems(items) {
    return fetchJSON(route('cart/add.js'), { method: 'POST', body: JSON.stringify({ items: items }) });
  }
  function addForm(formData) {
    return fetchJSON(route('cart/add.js'), { method: 'POST', body: formData });
  }
  function changeItem(key, qty) {
    return fetchJSON(route('cart/change.js'), { method: 'POST', body: JSON.stringify({ id: key, quantity: qty }) });
  }
  function updateItems(updates) {
    return fetchJSON(route('cart/update.js'), { method: 'POST', body: JSON.stringify({ updates: updates }) });
  }
  function getProduct(handle) {
    return fetchJSON(route('products/' + encodeURIComponent(handle) + '.js'));
  }

  /* ===== GIFT ===== */
  function countSubs(c) {
    return c.items.filter(function (i) { return i.selling_plan_allocation && !isGift(i); })
      .reduce(function (s, i) { return s + i.quantity; }, 0);
  }
  function isGift(i) {
    var value = i && i.properties && i.properties._gift_item;
    return value === true || String(value || '').toLowerCase() === 'true';
  }
  function isTierGift(i) { return isGift(i) && !!i.properties._tier_gift; }
  function isSubscriptionGift(i) { return isGift(i) && !i.properties._tier_gift; }

  function firstAvailableVariant(product) {
    if (!product || !product.variants) return null;
    return product.variants.find(function (variant) { return variant.available !== false; }) || null;
  }

  function resolveGiftVariant(config) {
    var configured = String(config.giftVariantId || '').trim();
    if (configured) return Promise.resolve(configured);
    if (!config.giftHandle) return Promise.reject(new Error('Gift product is not configured'));
    return getProduct(config.giftHandle).then(function (product) {
      var variant = firstAvailableVariant(product);
      if (!variant) throw new Error('Gift product has no available variant');
      config.giftVariantId = String(variant.id);
      return config.giftVariantId;
    });
  }

  function updateGiftUI(c) {
    if (!D.gift) return;
    var giftLine = c.items.find(isSubscriptionGift);
    var n = giftLine ? giftLine.quantity : 0;
    if (n > 0) { D.gift.classList.remove('cs-hidden'); if (D.giftQty) { if (n > 1) { D.giftQty.textContent = '\u00d7' + n; D.giftQty.classList.remove('cs-hidden'); } else D.giftQty.classList.add('cs-hidden'); } }
    else D.gift.classList.add('cs-hidden');
  }

  /* ===== TRACKING ===== */
  function trackCheckout(c) {
    if (!c) return;
    var items = c.items.filter(function (i) { return !isGift(i); });
    var ids = items.map(function (i) { return String(i.variant_id); });
    var val = c.total_price / 100, cur = c.currency || C.currency;
    var qty = items.reduce(function (s, i) { return s + i.quantity; }, 0);
    try { if (typeof fbq === 'function') fbq('track', 'InitiateCheckout', { content_ids: ids, contents: items.map(function (i) { return { id: String(i.variant_id), quantity: i.quantity, item_price: i.final_price / 100 }; }), content_type: 'product', num_items: qty, value: val, currency: cur }); } catch (e) {}
    try { if (typeof gtag === 'function') gtag('event', 'begin_checkout', { currency: cur, value: val, items: items.map(function (i, x) { return { item_id: String(i.variant_id), item_name: i.product_title, item_variant: i.variant_title, price: i.final_price / 100, quantity: i.quantity, index: x }; }) }); } catch (e) {}
    try { if (typeof ttq !== 'undefined' && ttq.track) ttq.track('InitiateCheckout', { content_id: ids[0], content_type: 'product', quantity: qty, value: val, currency: cur }); } catch (e) {}
    try { if (typeof snaptr === 'function') snaptr('track', 'START_CHECKOUT', { price: val, currency: cur, number_items: qty, item_ids: ids }); } catch (e) {}
    try { if (typeof pintrk === 'function') pintrk('track', 'checkout', { value: val, currency: cur, line_items: items.map(function (i) { return { product_id: String(i.variant_id), product_quantity: i.quantity, product_price: i.final_price / 100 }; }) }); } catch (e) {}
    try { if (typeof Shopify !== 'undefined' && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('checkout_started', { checkout: { totalPrice: val, currencyCode: cur } }); } catch (e) {}
    document.dispatchEvent(new CustomEvent('cart:initiate_checkout', { detail: { cart: c } }));
  }

  function trackATC(item, c) {
    var val = ((item.final_price || item.price || 0) / 100), cur = (c && c.currency) || C.currency;
    var id = String(item.variant_id || item.id), name = item.product_title || item.title || '';
    try { if (typeof fbq === 'function') fbq('track', 'AddToCart', { content_ids: [id], content_type: 'product', content_name: name, value: val, currency: cur }); } catch (e) {}
    try { if (typeof gtag === 'function') gtag('event', 'add_to_cart', { currency: cur, value: val, items: [{ item_id: id, item_name: name, price: val, quantity: item.quantity || 1 }] }); } catch (e) {}
    try { if (typeof ttq !== 'undefined' && ttq.track) ttq.track('AddToCart', { content_id: id, content_type: 'product', content_name: name, quantity: item.quantity || 1, value: val, currency: cur }); } catch (e) {}
    document.dispatchEvent(new CustomEvent('cart:add_to_cart', { detail: { item: item, cart: c } }));
  }

  /* ===== RENDER ===== */
  function updateHeaderCartCount(count) {
    $$('[data-bind="itemCount"]').forEach(function (el) { el.textContent = count; });
    $$('.header-cart').forEach(function (el) { el.classList.toggle('has-cart-count', count > 0); });
    document.dispatchEvent(new CustomEvent('cart:count-updated', { detail: { count: count } }));
  }

  function render(c) {
    if (!c || !Array.isArray(c.items)) return;
    cart = c;
    if (c.currency) C.currency = c.currency;
    var items = c.items.filter(function (i) { return !isGift(i); });
    var count = typeof c.item_count === 'number'
      ? c.item_count
      : c.items.reduce(function (s, i) { return s + i.quantity; }, 0);

    if (D.count) D.count.textContent = count;
    updateHeaderCartCount(count);

    if (count === 0) {
      D.empty && D.empty.classList.remove('cs-hidden');
      D.items && D.items.classList.add('cs-hidden');
      D.footer && D.footer.classList.add('cs-hidden');
      D.gift && D.gift.classList.add('cs-hidden');
      D.blocks && D.blocks.classList.add('cs-hidden');
      D.progressBar && D.progressBar.classList.add('cs-hidden');
      renderUpsells(c);
      return;
    }
    D.empty && D.empty.classList.add('cs-hidden');
    D.items && D.items.classList.remove('cs-hidden');
    D.footer && D.footer.classList.remove('cs-hidden');
    D.blocks && D.blocks.classList.remove('cs-hidden');

    renderItems(items);
    renderProgressBar(c);
    renderDiscounts(c);
    renderTotals(c);
    updateGiftUI(c);
    renderUpsells(c);
  }

  /** Get the "true" original price per line, factoring in selling_plan compare_at */
  function trueOrigLine(item) {
    if (item.selling_plan_allocation && item.selling_plan_allocation.compare_at_price) {
      return item.selling_plan_allocation.compare_at_price * item.quantity;
    }
    return item.original_line_price;
  }

  function renderItems(items) {
    if (!D.items) return;
    D.items.innerHTML = items.map(function (item) {
      var origLine = trueOrigLine(item);
      var save = origLine > item.final_line_price;
      var ld = item.line_level_discount_allocations || [];
      var image = typeof item.image === 'string'
        ? item.image
        : (item.image && (item.image.url || item.image.src)) || '';
      image = sizedImg(image, 180);
      var imageHTML = image
        ? '<img src="' + escA(image) + '" alt="' + escA(item.title) + '" width="' + (C.imageSize || 64) + '" height="' + (C.imageSize || 64) + '" loading="lazy">'
        : '';

      var propsHTML = '';
      if (item.properties) {
        Object.keys(item.properties).forEach(function (k) {
          if (k.charAt(0) !== '_' && item.properties[k]) {
            propsHTML += '<span class="cs-item__prop">' + esc(k) + ': ' + esc(String(item.properties[k])) + '</span>';
          }
        });
      }

      return '<div class="cs-item" data-cs-item data-key="' + escA(item.key) + '">' +
        '<div class="cs-item__img"><a href="' + escA(item.url) + '" tabindex="-1" aria-hidden="true">' + imageHTML + '</a></div>' +
        '<div class="cs-item__info">' +
          '<a href="' + escA(item.url) + '" class="cs-item__title">' + esc(item.product_title) + '</a>' +
          (item.variant_title && item.variant_title !== 'Default Title' ? '<span class="cs-item__variant">' + esc(item.variant_title) + '</span>' : '') +
          propsHTML +
          (ld.length ? ld.map(function (d) { return '<span class="cs-item__discount">' + esc(d.discount_application.title) + ': -' + formatMoney(d.amount) + '</span>'; }).join('') : save ? '<span class="cs-item__discount">Save ' + formatMoney(origLine - item.final_line_price) + '</span>' : '') +
          '<div class="cs-item__row"><div class="cs-qty">' +
            '<button class="cs-qty__btn" data-cs-minus aria-label="Decrease quantity" type="button">\u2212</button>' +
            '<input class="cs-qty__val" type="number" value="' + item.quantity + '" min="1" max="99" data-cs-qty-input aria-label="Quantity" inputmode="numeric">' +
            '<button class="cs-qty__btn" data-cs-plus aria-label="Increase quantity" type="button">+</button>' +
          '</div><div class="cs-item__prices">' +
            (save ? '<span class="cs-item__was">' + formatMoney(origLine) + '</span>' : '') +
            '<span class="cs-item__price">' + formatMoney(item.final_line_price) + '</span>' +
          '</div></div>' +
        '</div>' +
        '<button class="cs-item__remove" data-cs-remove aria-label="Remove ' + escA(item.product_title) + '" type="button"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>' +
      '</div>';
    }).join('');
  }

  /* ===== MULTI-TIER PROGRESS BAR ===== */
  var TIER_ICONS = { shipping: '\uD83D\uDE9A', gift: '\uD83C\uDF81', discount: '\uD83C\uDFF7\uFE0F', star: '\u2B50', none: '' };
  var milestonesBuilt = false;

  function renderProgressBar(c) {
    var tiers = C.tiers;
    if (!tiers || !tiers.length || !D.progressBar) {
      if (D.progressBar) D.progressBar.classList.add('cs-hidden');
      return;
    }

    D.progressBar.classList.remove('cs-hidden');

    /* Sort tiers by threshold ascending */
    var sorted = tiers.slice().sort(function (a, b) { return a.threshold - b.threshold; });
    var maxThreshold = sorted[sorted.length - 1].threshold;
    var spent = c.total_price;

    /* Find the next unlocked tier (first one where spent < threshold) */
    var nextTier = null;
    for (var i = 0; i < sorted.length; i++) {
      if (spent < sorted[i].threshold) {
        nextTier = sorted[i];
        break;
      }
    }

    /* Progress fill: percentage towards the max tier */
    var pct = maxThreshold > 0 ? Math.min((spent / maxThreshold) * 100, 100) : 100;
    if (D.progressFill) D.progressFill.style.width = pct + '%';

    /* Text: show next tier's "before" text, or last tier's "after" text if all unlocked */
    if (D.progressText) {
      if (nextTier) {
        var rem = nextTier.threshold - spent;
        var icon = TIER_ICONS[nextTier.icon] || '';
        D.progressText.innerHTML = (icon ? '<span class="cs-progress-bar__icon">' + icon + '</span> ' : '') +
          esc(decHTML(nextTier.textBefore.replace('[amount]', formatMoney(rem))));
      } else {
        var last = sorted[sorted.length - 1];
        var icon2 = TIER_ICONS[last.icon] || '';
        D.progressText.innerHTML = (icon2 ? '<span class="cs-progress-bar__icon">' + icon2 + '</span> ' : '') +
          esc(decHTML(last.textAfter));
      }
    }

    /* Milestones: build once, then just toggle unlocked class. Skip for single tier. */
    if (sorted.length > 1 && !milestonesBuilt && D.milestones) {
      D.milestones.innerHTML = sorted.map(function (t, idx) {
        var pos = maxThreshold > 0 ? (t.threshold / maxThreshold) * 100 : 100;
        var ic = TIER_ICONS[t.icon] || '';
        return '<div class="cs-milestone" data-tier-idx="' + idx + '" style="left:' + pos + '%">' +
          (ic ? '<span class="cs-milestone__icon">' + ic + '</span>' : '<span class="cs-milestone__dot"></span>') +
        '</div>';
      }).join('');
      milestonesBuilt = true;
    }
    /* Update unlocked state */
    if (sorted.length > 1 && D.milestones) {
      $$('.cs-milestone', D.milestones).forEach(function (el) {
        var idx = parseInt(el.dataset.tierIdx, 10);
        if (spent >= sorted[idx].threshold) el.classList.add('cs-milestone--unlocked');
        else el.classList.remove('cs-milestone--unlocked');
      });
    }
  }

  /* ===== IDEMPOTENT GIFT RECONCILIATION ===== */
  function reconcileGifts(c) {
    var current = c;
    var subscriptionNeed = C.giftEnabled && C.giftHandle ? countSubs(c) : 0;
    var eligibleTiers = (C.tiers || []).filter(function (tier) {
      return tier.type === 'gift' && tier.giftHandle && c.total_price >= tier.threshold;
    });
    var resolutions = [];

    if (subscriptionNeed > 0) {
      resolutions.push(resolveGiftVariant(C).then(function (id) {
        return { kind: 'subscription', id: String(id), quantity: subscriptionNeed, config: C };
      }));
    }
    eligibleTiers.forEach(function (tier) {
      resolutions.push(resolveGiftVariant(tier).then(function (id) {
        return { kind: 'tier', id: String(id), quantity: 1, config: tier };
      }));
    });

    return Promise.all(resolutions).then(function (desired) {
      var updates = {};
      var additions = [];
      var activeTierIds = {};
      var configuredGiftVariants = {};

      if (C.giftVariantId) configuredGiftVariants[String(C.giftVariantId)] = true;
      (C.tiers || []).forEach(function (tier) {
        if (tier.giftVariantId) configuredGiftVariants[String(tier.giftVariantId)] = true;
      });
      desired.forEach(function (gift) { configuredGiftVariants[gift.id] = true; });

      function removeLines(lines) {
        lines.forEach(function (line) { updates[line.key] = 0; });
      }

      /* A configured $0 gift added without the private entitlement properties is
         never a customer-purchasable line. Clean it up in the storefront layer. */
      removeLines(c.items.filter(function (line) {
        return !isGift(line) && configuredGiftVariants[String(line.variant_id)];
      }));

      var subscriptionLines = c.items.filter(isSubscriptionGift);
      var desiredSubscription = desired.find(function (gift) { return gift.kind === 'subscription'; });
      if (!desiredSubscription) {
        removeLines(subscriptionLines);
      } else {
        var matchingSubscription = subscriptionLines.filter(function (line) {
          return String(line.variant_id) === desiredSubscription.id;
        });
        removeLines(subscriptionLines.filter(function (line) {
          return String(line.variant_id) !== desiredSubscription.id;
        }));
        if (matchingSubscription.length) {
          if (matchingSubscription[0].quantity !== desiredSubscription.quantity) {
            updates[matchingSubscription[0].key] = desiredSubscription.quantity;
          }
          removeLines(matchingSubscription.slice(1));
        } else {
          additions.push({
            id: parseInt(desiredSubscription.id, 10),
            quantity: desiredSubscription.quantity,
            properties: { _gift_item: 'true', _gift_kind: 'subscription' }
          });
        }
      }

      desired.filter(function (gift) { return gift.kind === 'tier'; }).forEach(function (gift) {
        var tier = gift.config;
        activeTierIds[tier.id] = true;
        var tierLines = c.items.filter(function (line) {
          return isTierGift(line) && line.properties._tier_gift === tier.id;
        });
        var matchingTier = tierLines.filter(function (line) { return String(line.variant_id) === gift.id; });
        removeLines(tierLines.filter(function (line) { return String(line.variant_id) !== gift.id; }));
        if (matchingTier.length) {
          if (matchingTier[0].quantity !== 1) updates[matchingTier[0].key] = 1;
          removeLines(matchingTier.slice(1));
        } else {
          additions.push({
            id: parseInt(gift.id, 10),
            quantity: 1,
            properties: { _gift_item: 'true', _gift_kind: 'tier', _tier_gift: tier.id }
          });
        }
      });

      c.items.filter(isTierGift).forEach(function (line) {
        if (!activeTierIds[line.properties._tier_gift]) updates[line.key] = 0;
      });

      var updateKeys = Object.keys(updates);
      var chain = updateKeys.length ? updateItems(updates).then(function (updated) {
        current = updated;
        return updated;
      }) : Promise.resolve(current);

      if (additions.length) {
        chain = chain.then(function () { return addItems(additions); }).then(getCart).then(function (updated) {
          current = updated;
          return updated;
        });
      }
      return chain;
    }).catch(function (e) {
      console.warn('CS:gifts', e);
      toast('Free gift is temporarily unavailable');
      return current;
    });
  }

  function renderDiscounts(c) {
    if (!D.discounts) return;
    var d = c.cart_level_discount_applications || [];
    if (!d.length) { D.discounts.classList.add('cs-hidden'); D.discounts.innerHTML = ''; return; }
    D.discounts.classList.remove('cs-hidden');
    D.discounts.innerHTML = d.map(function (disc) {
      return '<div class="cs-footer__disc-row"><span class="cs-footer__disc-name"><svg width="10" height="10" viewBox="0 0 24 24" fill="var(--cs-green)" aria-hidden="true"><path d="M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58s1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41s-.23-1.06-.59-1.42z"/></svg>' + esc(disc.title) + '</span><span class="cs-footer__disc-amount">-' + formatMoney(disc.total_allocated_amount) + '</span></div>';
    }).join('');
  }

  function renderTotals(c) {
    if (D.total) D.total.textContent = formatMoney(c.total_price);
    /* Calculate "true" original using selling_plan compare_at where available,
       and gift compare_at for gift items (they pay £0 but the product has real value) */
    var trueOrig = 0;
    /* Build a map of tier gift compare_at values by tier ID */
    var tierGiftCompare = {};
    if (C.tiers) {
      C.tiers.forEach(function (t) {
        if (t.type === 'gift' && t.giftCompareAt) tierGiftCompare[t.id] = t.giftCompareAt;
      });
    }
    c.items.forEach(function (i) {
      if (i.properties && i.properties._gift_item) {
        if (i.properties._tier_gift && tierGiftCompare[i.properties._tier_gift]) {
          /* Tier gift: use tier-specific compare_at */
          trueOrig += tierGiftCompare[i.properties._tier_gift] * i.quantity;
        } else if (C.giftCompareAt && C.giftCompareAt > 0) {
          /* Subscription gift: use global giftCompareAt */
          trueOrig += C.giftCompareAt * i.quantity;
        }
        return;
      }
      if (i.selling_plan_allocation && i.selling_plan_allocation.compare_at_price) {
        trueOrig += i.selling_plan_allocation.compare_at_price * i.quantity;
      } else {
        trueOrig += i.original_line_price;
      }
    });
    var sav = trueOrig - c.total_price;
    if (sav > 0) {
      if (D.origTotal) { D.origTotal.textContent = formatMoney(trueOrig); D.origTotal.classList.remove('cs-hidden'); }
      D.savings && D.savings.classList.remove('cs-hidden');
      if (D.savingsVal) D.savingsVal.textContent = '-' + formatMoney(sav);
    } else {
      D.origTotal && D.origTotal.classList.add('cs-hidden');
      D.savings && D.savings.classList.add('cs-hidden');
    }
  }

  /* ===== ITEM EVENTS ===== */
  function setupItemEvents() {
    if (!D.items) return;
    D.items.addEventListener('click', function (e) {
      var control = e.target.closest && e.target.closest('[data-cs-remove],[data-cs-minus],[data-cs-plus]');
      if (!control || !D.items.contains(control)) return;
      var el = control.closest('[data-cs-item]');
      if (!el) return;
      var key = el.dataset.key;
      var inp = $('[data-cs-qty-input]', el);
      if (control.hasAttribute('data-cs-remove')) return queueQty(el, key, 0, null);
      var current = parseInt(inp.value, 10);
      if (isNaN(current)) current = 1;
      var qty = control.hasAttribute('data-cs-minus') ? Math.max(0, current - 1) : Math.min(99, current + 1);
      inp.value = qty;
      queueQty(el, key, qty, control.hasAttribute('data-cs-minus') ? '[data-cs-minus]' : '[data-cs-plus]');
    });
    D.items.addEventListener('input', function (e) {
      var inp = e.target.closest && e.target.closest('[data-cs-qty-input]');
      if (!inp || !D.items.contains(inp)) return;
      clearTimeout(inp._csDebounce);
      inp._csDebounce = setTimeout(function () {
        var el = inp.closest('[data-cs-item]');
        if (!el) return;
        var qty = parseInt(inp.value, 10);
        if (isNaN(qty) || qty < 1) qty = 1;
        qty = Math.min(99, qty);
        inp.value = qty;
        queueQty(el, el.dataset.key, qty, '[data-cs-qty-input]');
      }, 500);
    });
  }

  function queueQty(el, key, qty, focusSelector) {
    // Immediate visual feedback
    var btns = el.querySelectorAll('.cs-qty__btn');
    btns.forEach(function (b) { b.disabled = true; });
    if (qty === 0) {
      el.classList.add('is-removing');
    } else {
      el.classList.add('is-updating');
    }
    enqueue(function () {
      return changeItem(key, qty).then(function (c) {
        var found = c.items.find(function (i) { return i.key === key; });
        if (found && qty > 0 && found.quantity < qty) {
          toast('Only ' + found.quantity + ' available');
        }
        return reconcileGifts(c);
      }).then(function (c) {
        render(c);
        var updatedItem = $$('[data-cs-item]', D.items).find(function (item) { return item.dataset.key === key; });
        var updated = updatedItem && $('.cs-item__price', updatedItem);
        if (updated) { updated.classList.add('cs-flash'); setTimeout(function () { updated.classList.remove('cs-flash'); }, 400); }
        var focusTarget = updatedItem && focusSelector && $(focusSelector, updatedItem);
        if (focusTarget) focusTarget.focus();
      }).catch(function (e) {
        console.error('CS:qty', e);
        toast();
        return getCart().then(render).catch(function () {
          el.classList.remove('is-removing', 'is-updating');
          btns.forEach(function (b) { b.disabled = false; });
        });
      });
    });
  }

  /* ===== UPSELL RENDER (dynamic) ===== */
  function renderUpsells(c) {
    if (!C.upsellsEnabled || !D.upsellsGrid) {
      D.upsells && D.upsells.classList.add('cs-hidden');
      return;
    }
    var items = c.items.filter(function (i) { return !isGift(i); });
    var count = items.reduce(function (s, i) { return s + i.quantity; }, 0);
    if (count === 0) { D.upsells && D.upsells.classList.add('cs-hidden'); return; }

    var cartPids = {};
    items.forEach(function (i) { cartPids[i.product_id] = true; });

    /* Rule-based upsells: first matching market-eligible rule wins. */
    var pool = null;
    var eligibleRules = (C.upsellRules || []).filter(marketAllowed);
    if (eligibleRules.length) {
      var cartSkus = items.map(function (i) { return (i.sku || '').toLowerCase(); });
      /* Pass 1: exact match */
      for (var r = 0; r < eligibleRules.length; r++) {
        var trigger = (eligibleRules[r].triggerSku || '').toLowerCase();
        if (!trigger) continue;
        for (var s = 0; s < cartSkus.length; s++) {
          if (cartSkus[s] === trigger) {
            pool = (eligibleRules[r].upsells || []).filter(marketAllowed);
            break;
          }
        }
        if (pool) break;
      }
      /* Pass 2: contains match (only if no exact match found) */
      if (!pool) {
        for (var r2 = 0; r2 < eligibleRules.length; r2++) {
          var trigger2 = (eligibleRules[r2].triggerSku || '').toLowerCase();
          if (!trigger2) continue;
          for (var s2 = 0; s2 < cartSkus.length; s2++) {
            if (cartSkus[s2].indexOf(trigger2) !== -1) {
              pool = (eligibleRules[r2].upsells || []).filter(marketAllowed);
              break;
            }
          }
          if (pool) break;
        }
      }
    }
    /* Fallback to global upsells if no rule matched */
    if (!pool || !pool.length) pool = (C.upsells || []).filter(marketAllowed);
    if (!pool || !pool.length) {
      D.upsells && D.upsells.classList.add('cs-hidden');
      D.upsellsGrid.innerHTML = '';
      return;
    }

    var maxItems = Math.max(1, parseInt(C.upsellMaxItems || 2, 10));
    var visible = pool.filter(function (u) { return marketAllowed(u) && !cartPids[u.productId]; }).slice(0, maxItems);
    if (!visible.length) {
      D.upsells && D.upsells.classList.add('cs-hidden');
      D.upsellsGrid.innerHTML = '';
      return;
    }

    D.upsells && D.upsells.classList.remove('cs-hidden');
    D.upsellsGrid.innerHTML = visible.map(function (u) {
      var price = parseInt(u.price, 10) || 0;
      var compareAt = parseInt(u.compareAt, 10) || 0;
      var discounted = compareAt > price;
      var percentage = discounted ? Math.round(((compareAt - price) / compareAt) * 100) : 0;
      var imageHTML = u.image ? '<img src="' + escA(u.image) + '" alt="' + escA(u.name) + '" width="64" height="64" loading="lazy">' : '';
      var compareHTML = discounted && C.upsellShowCompareAt !== false
        ? '<span class="cs-upsell__was">' + formatMoney(compareAt) + '</span>'
        : '';
      var savingsHTML = discounted && C.upsellShowSavings !== false
        ? '<span class="cs-upsell__saving">' + esc(String(C.upsellSavingsText || 'Save [percent]%').replace('[percent]', percentage)) + '</span>'
        : '';
      var benefitHTML = u.benefit ? '<div class="cs-upsell__benefit">' + esc(u.benefit) + '</div>' : '';
      var buttonText = C.upsellButtonText || 'Add +';
      return '<div class="cs-upsell" data-cs-upsell data-upsell-id="' + u.variantId + '" data-upsell-product-id="' + u.productId + '">' +
        '<div class="cs-upsell__img">' + imageHTML + '</div>' +
        '<div class="cs-upsell__content"><div class="cs-upsell__name">' + esc(u.name) + '</div>' + benefitHTML +
        '<div class="cs-upsell__pricing">' + compareHTML + '<span class="cs-upsell__price">' + formatMoney(price) + '</span>' + savingsHTML + '</div></div>' +
        '<button class="cs-upsell__add" data-cs-upsell-add type="button" aria-label="' + escA(buttonText + ' ' + u.name) + '">' + esc(buttonText) + '</button>' +
      '</div>';
    }).join('');
  }

  function setupUpsellEvents() {
    if (!D.upsellsGrid) return;
    D.upsellsGrid.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-cs-upsell-add]');
      if (!btn || !D.upsellsGrid.contains(btn)) return;
      var el = btn.closest('[data-cs-upsell]');
      if (!el) return;
      var originalText = btn.textContent;
      btn.textContent = C.upsellAddingText || 'Adding…'; btn.disabled = true;
      enqueue(function () {
        return addToCart(el.dataset.upsellId, 1).then(function (res) {
          var added = res.items ? res.items[0] : res;
          return getCart().then(function (c) { trackATC(added, c); return reconcileGifts(c); });
        }).then(render).catch(function (err) {
          console.error('CS:upsell', err);
          btn.textContent = originalText; btn.disabled = false; toast(err.message);
        });
      });
    });
  }

  /* ===== FOCUS TRAP ===== */
  function setupFocusTrap() {
    D.drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !isOpen) return;
      var f = Array.prototype.slice.call(D.drawer.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),[tabindex]:not([tabindex="-1"])')).filter(function (el) {
        return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
      });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });
  }

  /* ===== iOS SCROLL LOCK ===== */
  function lockScroll() {
    if (unlockTimer) { clearTimeout(unlockTimer); unlockTimer = null; }
    /* A rapid close/reopen happens before the delayed unlock. Preserve the
       original page styles instead of snapshotting the already-locked body. */
    if (savedBodyStyles) return;
    scrollY = window.scrollY;
    savedBodyStyles = {
      position: document.body.style.position,
      top: document.body.style.top,
      left: document.body.style.left,
      right: document.body.style.right,
      overflow: document.body.style.overflow,
      paddingRight: document.body.style.paddingRight
    };
    document.documentElement.style.setProperty('--cs-scrollbar', sbw() + 'px');
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.overflow = 'hidden';
    if (sbw() > 0) document.body.style.paddingRight = sbw() + 'px';
  }
  function unlockScroll() {
    if (!savedBodyStyles || isOpen) return;
    Object.keys(savedBodyStyles).forEach(function (key) { document.body.style[key] = savedBodyStyles[key]; });
    savedBodyStyles = null;
    document.documentElement.style.removeProperty('--cs-scrollbar');
    window.scrollTo(0, scrollY);
  }

  /* ===== PROGRESS BAR ===== */
  function showProgress() {
    if ($('[data-cs-progress]')) return;
    var bar = document.createElement('div');
    bar.className = 'cs-progress'; bar.setAttribute('data-cs-progress', '');
    bar.innerHTML = '<div class="cs-progress__bar"></div>';
    // Insert after header (before shipping bar or body)
    var header = D.drawer.querySelector('.cs-header');
    if (header && header.nextSibling) header.parentNode.insertBefore(bar, header.nextSibling);
    else D.drawer.appendChild(bar);
  }
  function hideProgress() {
    var p = $('[data-cs-progress]');
    if (p) p.remove();
  }

  /* ===== OPEN / CLOSE ===== */
  function open() {
    if (isOpen) return;
    isOpen = true;
    lastFocused = document.activeElement;
    lockScroll();
    D.drawer.classList.add('is-open');
    D.overlay.classList.add('is-active');
    D.drawer.setAttribute('aria-hidden', 'false');
    D.close && D.close.focus();
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    D.drawer.classList.remove('is-open');
    D.overlay.classList.remove('is-active');
    D.overlay.setAttribute('aria-hidden', 'true');
    D.drawer.setAttribute('aria-hidden', 'true');
    hideProgress();
    unlockTimer = setTimeout(function () { unlockTimer = null; unlockScroll(); }, 320);
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    /* Pulse cart icon badge to remind user items are waiting */
    if (cart && cart.item_count > 0) {
      $$('[data-bind="itemCount"]').forEach(function (el) {
        el.classList.remove('cs-badge-pulse');
        void el.offsetWidth; /* force reflow to restart animation */
        el.classList.add('cs-badge-pulse');
      });
    }
  }

  function addingHTML() {
    var row = '<div class="cs-skeleton-item"><div class="cs-skeleton-img cs-shimmer"></div><div class="cs-skeleton-lines"><div class="cs-shimmer" style="width:70%;height:12px"></div><div class="cs-shimmer" style="width:40%;height:10px"></div><div class="cs-shimmer" style="width:50%;height:10px"></div></div></div>';
    return '<div class="cs-skeleton" data-cs-skeleton>' +
      '<div class="cs-adding-msg"><div class="cs-adding-spinner"></div><span>Adding to cart\u2026</span></div>' +
      row + '</div>';
  }

  /** Standard refresh — progress bar + fetch + render */
  function refresh() {
    if (refreshPromise) return refreshPromise;
    showProgress();
    refreshPromise = enqueue(function () {
      /* Reuse the in-flight startup read if the drawer is opened immediately. */
      var cartRead = initialCartPromise && !cart
        ? initialCartPromise.then(function (c) { return c || getCart(); })
        : getCart();
      return cartRead.then(reconcileGifts).then(function (c) {
        var sk = $('[data-cs-skeleton]');
        if (sk) sk.remove();
        hideProgress();
        render(c);
        if (highlightNext) {
          highlightNext = false;
          var first = $('[data-cs-item]', D.items);
          if (first) {
            first.classList.add('cs-item--just-added');
            setTimeout(function () { first.classList.remove('cs-item--just-added'); }, 1500);
          }
        }
        return c;
      });
    }).catch(function (e) {
      console.error('CS:refresh', e);
      var sk = $('[data-cs-skeleton]');
      if (sk) sk.remove();
      hideProgress();
      toast(e.message);
      return null;
    }).finally(function () { refreshPromise = null; });
    return refreshPromise;
  }

  /* ===== HIJACK CART ICON ===== */
  var CART_SELECTORS = [
    '[data-cs-open-cart]',
    'a[href="/cart"]', 'a[href="/cart/"]', 'a[href*="/cart?"]',
    'a[href$="/cart"]', 'a[href$="/cart/"]',
    '[data-cart-toggle]', '[data-action="toggle-cart"]',
    '.cart-icon-bubble', '.site-header__cart', '.header__icon--cart',
    '.js-cart-trigger', '.cart-link', '.header-cart-btn',
    '[aria-label="Cart"]', '[aria-label="cart"]'
  ].join(',');

  function isCartIcon(el) {
    if (!el) return false;
    if (el.matches && el.matches(CART_SELECTORS)) return true;
    var node = el, depth = 0;
    while (node && depth < 6) {
      if (node.tagName === 'A' && node.getAttribute('href') && /\/cart\/?(\?.*)?$/.test(node.getAttribute('href'))) {
        return !node.closest('#cs-drawer');
      }
      if (node.matches && node.matches('[data-cs-open-cart],[data-cart-toggle],[data-action="toggle-cart"]')) {
        return !node.closest('#cs-drawer');
      }
      node = node.parentElement;
      depth++;
    }
    return false;
  }

  /** One capture handler prevents the theme drawer and avoids duplicate refreshes. */
  function cartIconHandler(e) {
    if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (!isCartIcon(e.target)) return;
    if (e.target.closest && e.target.closest('#cs-drawer')) return;
    e.preventDefault();
    e.stopPropagation();
    open();
    refresh();
  }

  /* ===== URGENCY BAR ===== */
  function initUrgency() {
    if (!C.urgencyEnabled) return;
    var bar = $('[data-cs-urgency]');
    if (!bar) return;
    var countEl = $('[data-cs-urgency-count]', bar);
    var timerEl = $('[data-cs-urgency-timer]', bar);
    if (!countEl || !timerEl) return;

    var lo = C.urgencyMin || 7, hi = C.urgencyMax || 23;
    var count = lo + Math.floor(Math.random() * (hi - lo + 1));
    var secs = (C.urgencyTimer || 10) * 60;
    countEl.textContent = count;

    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function renderTimer() {
      var m = Math.floor(secs / 60), s = secs % 60;
      timerEl.textContent = pad(m) + ':' + pad(s);
    }
    renderTimer();

    // Countdown
    var tick = setInterval(function () {
      secs--;
      if (secs <= 0) {
        clearInterval(tick);
        clearInterval(flutter);
        bar.style.transition = 'opacity 0.4s, max-height 0.4s';
        bar.style.opacity = '0';
        bar.style.maxHeight = '0';
        bar.style.overflow = 'hidden';
        bar.style.marginBottom = '0';
        bar.style.paddingTop = '0';
        bar.style.paddingBottom = '0';
        return;
      }
      renderTimer();
    }, 1000);

    // Fluctuate count ±1-2 every 20-40s to feel live
    var flutter = setInterval(function () {
      var delta = Math.random() > 0.5 ? 1 : -1;
      if (Math.random() > 0.7) delta *= 2;
      count = Math.max(lo, Math.min(hi, count + delta));
      countEl.textContent = count;
    }, (20 + Math.floor(Math.random() * 20)) * 1000);
  }

  /* ===== INIT ===== */
  function init() {
    cacheDom();
    if (!D.drawer || !D.overlay) return; /* Section not mounted — safe no-op */
    D.drawer.setAttribute('aria-hidden', 'true');

    D.close && D.close.addEventListener('click', close);
    D.overlay && D.overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen) close(); });

    setupFocusTrap();
    setupItemEvents();
    setupUpsellEvents();
    initUrgency();

    /* Liquid knows the current Shopify item count immediately; keep every header
       variant in sync before the background cart read completes. */
    if (typeof C.initialCount === 'number') updateHeaderCartCount(C.initialCount);

    /* Warm the cart cache; mutations wait for this read so it cannot overwrite newer state. */
    initialCartPromise = getCart().then(function (c) {
      if (!cart) {
        cart = c;
        updateHeaderCartCount(c.item_count || 0);
      }
      return c;
    }).catch(function () { return null; });

    // ATC form hijack — OPTIMISTIC RENDER
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[action*="/cart/add"]');
      if (!form || e.defaultPrevented || form.dataset.csSubmitting === 'true') return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var fd;
      try { fd = new FormData(form, e.submitter); }
      catch (err) {
        fd = new FormData(form);
        if (e.submitter && e.submitter.name) fd.append(e.submitter.name, e.submitter.value || '');
      }
      var id = fd.get('id');
      var payload = null;
      if (id && !isNaN(parseInt(id, 10))) {
        var quantity = parseInt(fd.get('quantity') || '1', 10);
        if (isNaN(quantity) || quantity < 1) quantity = 1;
        payload = { id: parseInt(id, 10), quantity: quantity };
        var sp = fd.get('selling_plan');
        if (sp) payload.selling_plan = parseInt(sp, 10);
        var props = {};
        for (var pair of fd.entries()) {
          if (pair[0].indexOf('properties[') === 0 && typeof pair[1] === 'string') {
            props[pair[0].replace('properties[', '').replace(']', '')] = pair[1];
          }
        }
        if (Object.keys(props).length) payload.properties = props;
      }
      var btn = e.submitter || form.querySelector('[type="submit"],button:not([type="button"])');
      var orig = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
      form.dataset.csSubmitting = 'true';

      open();
      if (payload && cart) {
        var optItem = scrapeProductData(form, payload);
        var optCart = buildOptimisticCart(cart, optItem, payload);
        render(optCart);
        var first = $('[data-cs-item]', D.items);
        if (first) { first.classList.add('cs-item--just-added'); setTimeout(function () { first.classList.remove('cs-item--just-added'); }, 1500); }
      } else if (!cart || !cart.items || !cart.items.length) {
        D.empty && D.empty.classList.add('cs-hidden');
        if (!$('[data-cs-skeleton]')) D.body.insertAdjacentHTML('afterbegin', addingHTML());
      }

      showProgress();
      var operation = enqueue(function () {
        return Promise.resolve(initialCartPromise).then(function () { return addForm(fd); }).then(function (res) {
          var addedItems = res && res.items ? res.items : [res];
          return getCart().then(function (fc) {
            addedItems.filter(Boolean).forEach(function (added) { trackATC(added, fc); });
            return reconcileGifts(fc);
          });
        }).then(function (c) {
          hideProgress();
          var skeleton = $('[data-cs-skeleton]');
          if (skeleton) skeleton.remove();
          render(c);
          return c;
        }).catch(function (err) {
          console.error('CS:atc', err);
          hideProgress();
          toast('Could not add to cart. ' + (err.message || 'Please try again.'));
          return getCart().then(render).catch(function () {});
        });
      });
      operation.finally(function () {
        form.dataset.csSubmitting = 'false';
        if (btn) { btn.disabled = false; btn.innerHTML = orig; }
      });
    }, true);

    /**
     * Scrape product data from the PDP for optimistic rendering.
     * Tries JSON-LD, then meta tags, then DOM elements.
     */
    function scrapeProductData(form, payload) {
      var item = {
        key: 'optimistic_' + Date.now(),
        title: '',
        product_title: '',
        variant_title: '',
        url: window.location.pathname,
        image: '',
        price: 0,
        original_price: 0,
        final_price: 0,
        original_line_price: 0,
        final_line_price: 0,
        quantity: payload.quantity || 1,
        variant_id: payload.id,
        product_id: 0,
        selling_plan_allocation: null,
        properties: payload.properties || {},
        line_level_discount_allocations: []
      };

      /* Try JSON-LD structured data first */
      try {
        var ldScripts = document.querySelectorAll('script[type="application/ld+json"]');
        for (var i = 0; i < ldScripts.length; i++) {
          var ld = JSON.parse(ldScripts[i].textContent);
          if (ld['@type'] === 'Product' || (ld['@graph'] && ld['@graph'].find && ld['@graph'].find(function(g) { return g['@type'] === 'Product'; }))) {
            var prod = ld['@type'] === 'Product' ? ld : ld['@graph'].find(function(g) { return g['@type'] === 'Product'; });
            if (prod) {
              item.product_title = prod.name || '';
              item.title = item.product_title;
              var schemaImage = Array.isArray(prod.image) ? prod.image[0] : prod.image;
              item.image = typeof schemaImage === 'string' ? schemaImage : ((schemaImage && (schemaImage.url || schemaImage.contentUrl)) || '');
              var offer = prod.offers;
              if (Array.isArray(offer)) offer = offer[0];
              if (offer && offer.price) {
                var p = Math.round(parseFloat(offer.price) * 100);
                item.price = p; item.original_price = p; item.final_price = p;
              }
            }
            break;
          }
        }
      } catch (e) {}

      /* Fallback: meta tags */
      if (!item.product_title) {
        var ogTitle = document.querySelector('meta[property="og:title"]');
        if (ogTitle) { item.product_title = ogTitle.content || ''; item.title = item.product_title; }
      }
      if (!item.image) {
        var ogImg = document.querySelector('meta[property="og:image"]');
        if (ogImg) item.image = ogImg.content || '';
      }
      if (!item.price) {
        var priceMeta = document.querySelector('meta[property="product:price:amount"], meta[property="og:price:amount"]');
        if (priceMeta) {
          var p = Math.round(parseFloat(priceMeta.content) * 100);
          item.price = p; item.original_price = p; item.final_price = p;
        }
      }

      /* Fallback: form context */
      if (!item.product_title) {
        var heading = document.querySelector('h1');
        if (heading) { item.product_title = heading.textContent.trim(); item.title = item.product_title; }
      }

      /* Set line prices */
      item.original_line_price = item.original_price * item.quantity;
      item.final_line_price = item.final_price * item.quantity;

      return item;
    }

    /**
     * Build optimistic cart by merging cached cart with new item.
     * If the variant already exists, increment quantity.
     */
    function buildOptimisticCart(cached, optItem, payload) {
      var base = cached || { items: [], total_price: 0, original_total_price: 0, item_count: 0, cart_level_discount_applications: [], currency: C.currency };
      var newItems = JSON.parse(JSON.stringify(base.items));
      var found = false;

      function normalizedProperties(properties) {
        var out = {};
        Object.keys(properties || {}).sort().forEach(function (key) {
          if (properties[key] != null && properties[key] !== '') out[key] = String(properties[key]);
        });
        return JSON.stringify(out);
      }

      function sellingPlanId(item) {
        return item.selling_plan_allocation && item.selling_plan_allocation.selling_plan
          ? String(item.selling_plan_allocation.selling_plan.id)
          : '';
      }

      for (var i = 0; i < newItems.length; i++) {
        var samePlan = String(payload.selling_plan || '') === sellingPlanId(newItems[i]);
        var sameProperties = normalizedProperties(payload.properties) === normalizedProperties(newItems[i].properties);
        if (newItems[i].variant_id === payload.id && !isGift(newItems[i]) && samePlan && sameProperties) {
          newItems[i].quantity += (payload.quantity || 1);
          newItems[i].final_line_price = newItems[i].final_price * newItems[i].quantity;
          newItems[i].original_line_price = newItems[i].original_price * newItems[i].quantity;
          found = true;
          break;
        }
      }
      if (!found) {
        newItems.unshift(optItem); /* new item at top */
      }

      var totalPrice = 0;
      var totalOriginal = 0;
      var totalCount = 0;
      newItems.forEach(function (it) {
        totalPrice += it.final_line_price;
        totalOriginal += it.original_line_price;
        totalCount += it.quantity;
      });

      return {
        items: newItems,
        total_price: totalPrice,
        original_total_price: totalOriginal,
        item_count: totalCount,
        cart_level_discount_applications: base.cart_level_discount_applications || [],
        currency: base.currency || C.currency
      };
    }

    /* One handler only: prevents the legacy theme drawer without double-fetching. */
    document.addEventListener('click', cartIconHandler, true);

    // Checkout CTA
    document.addEventListener('click', function (e) {
      var cta = e.target.closest('[data-cs-checkout]');
      if (!cta) return;
      e.preventDefault();
      if (checkoutPending) return;
      checkoutPending = true;
      showProgress();
      enqueue(function () {
        return getCart().then(reconcileGifts).then(function (c) {
          trackCheckout(c);
          window.location.assign(cta.href || '/checkout');
        });
      }).catch(function (err) {
        console.error('CS:checkout', err);
        hideProgress();
        toast('Please wait while we update your cart, then try again.');
      }).finally(function () { checkoutPending = false; });
    });

    // Custom events
    document.addEventListener('cart:open', function () { open(); refresh(); });
    document.addEventListener('cart:close', close);
    document.addEventListener('cart:refresh', refresh);
    document.addEventListener('cart:item-added', function () { highlightNext = true; open(); refresh(); });

    // bfcache recovery
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) {
        if (isOpen) refresh();
        else getCart().then(function (c) {
          cart = c;
          if (c.currency) C.currency = c.currency;
          updateHeaderCartCount(c.item_count || 0);
        }).catch(function () {});
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.CartSlider = { open: open, close: close, refresh: refresh, getCart: function () { return cart; } };

  // Global hooks for theme/PDP JS
  window.OPEN_CART = function () {
    var cartWasEmpty = !cart || !cart.item_count;
    open();
    if (cartWasEmpty) {
      // Empty cart: hide empty state, show adding skeleton
      D.empty && D.empty.classList.add('cs-hidden');
      var existing = $('[data-cs-skeleton]');
      if (!existing) D.body.insertAdjacentHTML('afterbegin', addingHTML());
    }
    showProgress();
  };
  window.UPDATE_CART = function () {
    highlightNext = true;
    refresh();
  };
})();
